import { FormControlLabel, Grid, Switch } from "@mui/material";
import { FastField } from "formik";
import {
  ChonViTriBanDo,
  MySelect,
  MySelectTime,
  MyTextField,
  MyTextFieldArea,
  MyTextFieldUploadFile,
  ViTriDiaLy
} from "../Lib/componentLibrarys";
import Api from "../../api2";
import { useState } from "react";
import { isEmpty } from "lodash";
import { UploadMultiFile } from "../DanhMuc/Components";

export const FormNhap = ({ view, values, errors, setFieldValue }) => {
  const [phuongXaList, setPhuongXaList] = useState([]);
  const [quanHuyenList, setQuanHuyenList] = useState([]);
  const [tinhThanhList, setTinhThanhList] = useState([]);

  const getApiListDvhc = (cap, madvhc, setData) => {
    new Api()
      .GetListDvhc({ cap: cap, madvhc: madvhc })
      .then(data => {
        if (data.code === 200) {
          setData(data?.data?.result);
        }
      })
      .catch(err => {})
      .finally(() => {});
  };
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={6}>
          <FastField name="tenVungSanXuat">
            {({ field }) => (
              <MyTextField
                required
                disabled={view}
                label="Tên vùng sản xuất:"
                placeholder="Nhập..."
                errors={errors?.tenVungSanXuat}
                helperText={errors?.tenVungSanXuat}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="dienTich">
            {({ field }) => (
              <MyTextField
                disabled={view}
                type="number"
                label="Diện tích:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <MySelect
            disabled={view}
            label="Tỉnh thành:"
            placeholder="Chọn..."
            value={values?.tinhThanh}
            options={tinhThanhList}
            name="tenDVHC"
            onChange={(event, value) => {
              setFieldValue(`tinhThanh`, value);
              setFieldValue(`quanHuyen`, null);
              setFieldValue(`phuongXa`, null);
            }}
            onOpen={() => {
              isEmpty(tinhThanhList) && getApiListDvhc(1, "", setTinhThanhList);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            disabled={view}
            label="Quận huyện:"
            placeholder="Chọn..."
            value={values?.quanHuyen}
            options={quanHuyenList || []}
            name="tenDVHC"
            onChange={(event, value) => {
              setFieldValue(`quanHuyen`, value);
              setFieldValue(`phuongXa`, null);
            }}
            onOpen={() => {
              values?.tinhThanh?.maTinh &&
                getApiListDvhc(2, values.tinhThanh.maTinh, setQuanHuyenList);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            disabled={view}
            label="Phường xã:"
            placeholder="Chọn..."
            value={values?.phuongXa}
            options={phuongXaList || []}
            name="tenDVHC"
            onChange={(event, value) => {
              setFieldValue(`phuongXa`, value);
            }}
            onOpen={() => {
              values?.quanHuyen?.maHuyen &&
                getApiListDvhc(3, values.quanHuyen.maHuyen, setPhuongXaList);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <FastField name="diaChi">
            {({ field }) => (
              <MyTextField disabled={view} label="Địa chỉ:" placeholder="Nhập..." {...field} />
            )}
          </FastField>
        </Grid>
        {/* <Grid item xs={12}>
          <ViTriDiaLy
            valuesViTri={values?.viTriDiaLy}
            setFieldValue={setFieldValue}
          />
        </Grid> */}
        <Grid item xs={12}>
          <ChonViTriBanDo
            valuesViTri={values?.viTriDiaLy}
            setFieldValue={setFieldValue}
          />
        </Grid>
        <Grid item xs={12}>
          <FastField name="thongTinMoTa">
            {({ field }) => (
              <MyTextFieldArea
                disabled={view}
                label="Mô tả:"
                placeholder="Nhập..."
                maxRows={3}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={12}>
          <FastField name="ghiChu">
            {({ field }) => (
              <MyTextFieldArea
                disabled={view}
                label="Ghi chú:"
                placeholder="Nhập..."
                maxRows={3}
                {...field}
              />
            )}
          </FastField>
        </Grid>
      </Grid>
    </div>
  );
};
